











































import { computed, defineComponent, Ref, ref } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import { SMH } from '@/renderer/scripts/smh';
import { isDisabledAllAuth } from '@/renderer/scripts/utils/tools/index';
interface Handler {
  show: Ref<boolean>;
  openHelp: () => void;
}
export function helpHandler(): Handler {
  const show = ref(false);
  const openHelp = () => {
    show.value = true;
  };
  return {
    show,
    openHelp,
  };
}
export default defineComponent({
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    list: {
      type: Array,
      default: [],
    },
    attach: {
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    const vm = context.root;
    const baseColumns: Array<any> = [
      {
        colKey: 'name',
        title: i18n_t('角色'),
        width: 100,
      },
      {
        colKey: 'canView',
        title: i18n_t('查看列表'),
      },
      {
        colKey: 'canPreview',
        title: i18n_t('预览'),
      },
      {
        colKey: 'canDownload',
        title: i18n_t('下载'),
      },
      {
        colKey: 'canPrint',
        title: i18n_t('打印'),
      },
      {
        colKey: 'canUpload',
        title: i18n_t('上传'),
      },
      {
        colKey: 'canDelete',
        title: i18n_t('删除'),
      },
      {
        colKey: 'canModify',
        title: i18n_t('修改'),
      },
    ];
    const columns = computed(() => {
      const routeName = vm.$route.name as string;
      if (!routeName.includes('collaborationSpace')) {
        const authColumn = {
          colKey: 'canAuthorize',
          title: i18n_t('共享'),
        };
        const shareColumn = {
          colKey: 'canShare',
          title: i18n_t('分享'),
        };
        return [...baseColumns, authColumn, shareColumn];
      }
      // 协作空间权限详情不显示分享列
      return baseColumns;
    });
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const renderList = computed(() =>
      (props.list as SMH.Role[])
        .filter(role => {
          // 协作空间权限详情不显示操作者行
          const routeName = vm.$route.name as string;
          return (
            /* i18n-ignore */
            !routeName.includes('collaborationSpace') || (role.name !== '操作者' && !isDisabledAllAuth(role))
          );
        })
        .sort((a, b) => a.id - b.id),
    );
    return {
      columns,
      innerShow,
      renderList,
    };
  },
});
